import React from "react";
import logo from "../images/logo.png";
import fb from "../icons/fb.png";
import insta from "../icons/insta.png";
import what from "../icons/what.png";
import x from "../icons/x.png";
import { Link } from "react-router-dom";

const Navbar = () => {
  return (
    <>
      {/* <div className="topbar d-flex justify-content-between align-items-center bg-first p-2">
        <div>
          <p>Call Us: +919560856999</p>
        </div>

        <div>
          <p>
            Sign up and GET 25% OFF for you first order.{" "}
            <a href="">Sign Up now</a>
          </p>
        </div>
        <div className="topbar-social">
        <img src={fb} alt="" width={25} />
        <img src={what} alt="" width={25} />
        <img src={insta} alt="" width={25} />
        <img src={x} alt="" width={25} />

        </div>
      </div> */}

      <nav className="navbar navbar-expand-lg ">
        <div className="container-fluid">
          <Link to="/" className="navbar-brand" >
            <img src={logo} alt="" width={140} />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link to="/" className="nav-link active" aria-current="page" >
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/services">
                  Services
                </Link>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="/about-us">
                  About Us
                </a>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/contact-us">
                  Contact Us
                </Link>
              </li>
            </ul>
            <form className="d-flex" role="search">
              <button className="btn btn-primary">Get A Quote</button>
            </form>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
